// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o1bu","rootMobile":"styles_rootMobile__1bhq2"};